import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-settings',
  templateUrl: './ui-settings.component.html',
  styleUrls: ['./ui-settings.component.css'],
})
export class UiSettingsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
